import CryptoJS from 'crypto-js'
 
export default defineNuxtPlugin(({ nuxtApp, vueApp }) => {


  const uniq = {
    code: function() {
      var randomString = Math.random().toString(36).substring(2, 15);
      // var apiKey = useApiSecret();
      // var apiKey = useApiSecret() ? useApiSecret() : useCook('auth:api').value;
      var apiKey = useCook('auth:api').value ? useCook('auth:api') : useApiSecret();
      var guest = useAuth().getGuest();
      var string = randomString + apiKey.value + guest;
      var value = CryptoJS.SHA256(string).toString()
      return {code: value, rnd: randomString}
    }
  };

  return {
    provide: {
      uniq: uniq,
    },
  };

});


// export default defineNuxtPlugin(() => {
 
//   const apiCookie = useCook('auth:api')

//   // const apiCookie = useCookie('auth:api')

//   const uniq = {
//     code () {
//       const rnd   = Math.random().toString(36).slice(2, 15);
//       const api   = apiCookie.value || useApiSecret(); 
//       const guest = useAuth().getGuest();

//       const hash = CryptoJS.SHA256(rnd + api + guest).toString();
//       return { code: hash, rnd };
//     }
//   };

//   return { provide: { uniq } };
// });